import React from 'react'
import {_GPY} from '../../../env.js'

class Crawl extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      active: false,
      data  : undefined,
      overlayConfig: this.props.display.state.overlays!==undefined&&this.props.display.state.overlays[this.props.overlayConf]!==undefined?this.props.display.state.overlays[this.props.overlayConf].overlay:{},
      transition : "transition-start" ,
      text:"",
      items:[],
      restartAnim:false,
    };
  }

  onSetTimeout(){
  }

  onInit(overlayConfig){
      this.setState({transition: this.state.overlayConfig.transition +"-active"})
  }


  onData (data,key) {

    if(typeof data === 'object') {

        var doAnim = false;
        var tmp = [];
        if(data.text !== undefined ) {
          tmp = data.text.split("\n");
          data.token = tmp;
        }

        if(data.visible === undefined) {
            this.setState({ data:data,items:tmp });
        } else {
          if(data.visible === true ) {
              if(this.state.active !== data.visible) {
                  doAnim=true;
               }
               this.setState({active: data.visible, data:data,items:tmp} , ()=>{
                      if(doAnim) {
                        this.setState({restartAnim:true},()=>{
                            this.setState({restartAnim:false,active: data.visible, data:data,items:tmp, transition: this.state.overlayConfig.transition +"-active"});
                        })
                      }
               });
          } else {
              this.setState({active: data.visible } , ()=>{
                this.setState({active: data.visible, transition: this.state.overlayConfig.transition +"-leave"});
                /*
                this.interval = setInterval(() => {
                  clearInterval(this.interval);
                  this.setState({restartAnim:true});
                }, 2000);
                */
              });
          }
      }

    } else if( typeof data === 'number' ) {
        this.setState({numberData: data});
    } else if(typeof data === 'boolean') {
        this.setState({booleanData: data});
    }
  }

  componentDidMount() {
    this.props.display.registDataListener(this.props.stateName,this);
  }


  render() {

    if(this.state.data === undefined || this.state.overlayConfig === undefined || this.state.overlayConfig.elements === undefined) {
      return (<div className={this.state.transition}/>);
    }
    const text = this.state.overlayConfig.elements.text.element;
    const e = this.state.overlayConfig.elements.background.element;

    var gpyCrawlContent = document.getElementById( 'gpyCrawlContent' );
    var len = gpyCrawlContent!==null&&gpyCrawlContent!==undefined?gpyCrawlContent.offsetWidth:10;
    var sp = isNaN(parseInt(text.displayRule))?15*1000:parseInt(text.displayRule);

    var speed = sp;
    var c =  len>0 ? (len/text.width) : 0;
    var msToScroll = c < 1 ? speed: (c*speed);

    console.log("gpyCrawlContent Len: ",len,"msToScroll: ",msToScroll,"width",text.width,"speed",sp);

    console.log("gpyCrawlContent 0%: ",Math.floor(text.width),"100%: ", -(40+Math.floor(len)));

    return(
      <div  className={this.state.transition} style={{position : "absolute",top:'0px',left:'0px',width:'100%', height:'100%'}}>
      {this.state.data.crawlRightToLeft===undefined||this.state.data.crawlRightToLeft?
        <style>{`
            @keyframes marquee {
              0% { transform: translateX( +${Math.floor(text.width+(text.width/5))}px); }
              100% { transform: translateX( -${((text.width/5)+Math.floor(len))}px); }
            }
             @keyframes emptyanim {};
        `}</style>
      :
      <style>{`
          @keyframes marquee {
            0% { transform: translateX( -${ Math.floor((len+(text.width/5)))}px); }
            100% { transform: translateX(+${ Math.floor(text.width)+(text.width/5)}px); }
          }
           @keyframes emptyanim {};
      `}</style>}


        {e.enable && e.elementType === "image" && e.imageSrc !== undefined && e.imageSrc !== ''?
              <div  style={{ position : "absolute", opacity: e.opacity, left : e.x+"px", top :  e.y+"px", width : e.width+"px", height : e.height+"px", display: "flex", alignItems: e.valign, justifyContent: e.align }}>
                  <img alt="" className="image-fluid" style={{maxWidth: e.width + "px", maxHeight :e.height+"px"}}
                  src={_GPY.resource("upload/" + e.imageSrc )} />
              </div>
        :""}

          <div  style={{position : "absolute",left :text.x+"px",top : text.y+"px",width : text.width+"px",height : text.height+"px", display: "flex", whiteSpace: "nowrap",overflow: "hidden",boxSizing: "border-box"}}>
                <div className="marquee" id="gpyCrawlContent" style={{position : "absolute",left :"0px",top : "0px",height : text.height+"px", color :text.fontColor, fontFamily : text.font, fontSize : text.fontSize + "px", animation: (this.state.restartAnim?"emptyanim":"marquee "+msToScroll+"ms linear infinite forwards")}}>
                  { this.state.items.map((i)=>{
                      if(this.state.data.crawlRightToLeft===undefined||this.state.data.crawlRightToLeft){
                          return ( <span>
                           <img style={{maxWidth : text.fontSize + "px", maxHeight : text.fontSize + "px", marginLeft: text.fontSize + "px", marginRight:text.fontSize + "px"}} src={this.state.data.separatorImage!==undefined?_GPY.resource("upload/"+this.state.data.separatorImage):_GPY.resource("images/ball.gif")} className="img-fluid" alt=""/>
                           {i}
                          </span> );
                      } else {
                           return (<span>
                             {i}
                             <img style={{maxWidth : text.fontSize + "px", maxHeight : text.fontSize + "px", marginLeft: text.fontSize + "px", marginRight:text.fontSize + "px"}} src={this.state.data.separatorImage!==undefined?_GPY.resource("upload/"+this.state.data.separatorImage):_GPY.resource("images/ball.gif")} className="img-fluid" alt=""/>
                            </span>);
                      }
                  })}
                </div>
              </div>
      </div>
     )
  }
}
export default Crawl;
